import { render, staticRenderFns } from "./constructionProcedureTemplate.vue?vue&type=template&id=96506df0&scoped=true&"
import script from "./constructionProcedureTemplate.vue?vue&type=script&lang=js&"
export * from "./constructionProcedureTemplate.vue?vue&type=script&lang=js&"
import style0 from "./constructionProcedureTemplate.vue?vue&type=style&index=0&id=96506df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96506df0",
  null
  
)

export default component.exports